import { TOKEN_STARTER } from './tokenutils';

const removeWhitespace = (str) =>
  str.replace(
    /[\t\n\r\f\v\u00A0\u2002\u2003\u2009]|\u200B|\u200C|\u200D|\u3000|\s/g,
    '',
  );

const isTokenExactMatch = (token, filter) => {
  const filterCmp = removeWhitespace(filter.toLowerCase());
  const tokenCmp = removeWhitespace(token.text.toLowerCase());

  return tokenCmp === filterCmp;
};

const tokenFilterMatch = (token, filter) => {
  const filterCmp = removeWhitespace(filter.toLowerCase());
  const tokenCmp = removeWhitespace(token.text.toLowerCase());
  return tokenCmp.startsWith(filterCmp);
};

const splitGroupIntoUserTokens = (group, existingText, metadata) => {
  if (!Array.isArray(group.users) || group.users.length === 0) {
    return { updatedValue: existingText, updatedMetadata: metadata };
  }

  let usersMentionText = '';
  const updatedMetadata = [...metadata];

  const existingTextWithoutGroupToken = existingText.slice(
    0,
    existingText.lastIndexOf(TOKEN_STARTER),
  );

  group.users.forEach((user) => {
    const userTokenText = removeWhitespace(user.text);

    const newMetadataEntry = {
      len: userTokenText.length + 1,
      start:
        existingTextWithoutGroupToken.length +
        usersMentionText.length +
        TOKEN_STARTER.length -
        1,
      type: user.type,
      value: user.value,
    };
    updatedMetadata.push(newMetadataEntry);

    usersMentionText = usersMentionText.concat(
      `${TOKEN_STARTER}${userTokenText} `,
    );
  });
  const updatedValue = existingTextWithoutGroupToken.concat(usersMentionText);

  return { updatedValue, updatedMetadata };
};

export {
  splitGroupIntoUserTokens,
  removeWhitespace,
  isTokenExactMatch,
  tokenFilterMatch,
};
